export default "__VITE_ASSET__BgBWNK2h__"